const investorsRoutes = [
  {
    id: 'INVESTORS',
    fr: 'investisseurs/:pageUid',
    en: 'investors/:pageUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../pages/Investors'),
  },
];

export default investorsRoutes;
